module.exports = __webpack_public_path__ + "static/media/image-about.26cc037c.jpg";